import { SCHOOL } from "@rohome/common";
import { eq } from "drizzle-orm";
import { Form } from "react-router";
import { getAuthenticator } from "~/.server/services/auth";
import type { FunctionArgs } from "~/load-context";
import { AuthLayout } from "./components/AuthLayout";
import { ContinueWithROID } from "./components/ContinueWithROID";

export const loader = async (args: FunctionArgs) => {
  const context = args.context;
  const schools = await context.DB.query.SCHOOL.findMany();
  return {
    schools: schools.map((s) => ({
      id: s.id,
      name: s.name,
    })),
  };
};

export const action = async (args: FunctionArgs) => {
  const school = await args.context.DB.query.SCHOOL.findFirst({
    where: eq(SCHOOL.isRoSchool, true),
  });
  const authenticator = getAuthenticator(
    { ...args, context: args.context },
    school?.organizationId!
  );
  return authenticator.authenticate("roid", args.request);
};

export default function Index() {
  return (
    <AuthLayout>
      <Form method="post" style={{ width: "100%" }}>
        <ContinueWithROID
          fullWidth
          variant="light"
          label="Continue with ROID"
        />
      </Form>
    </AuthLayout>
  );
}
